import LoadingVIew from './loading-view';
export default LoadingVIew;